import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class Abstract extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): Abstract {
    return new Abstract(value);
  }

  /**
   * ラベル
   */
  static get label(): string {
    return '概要';
  }

  /**
   * PlaceHolder
   */
  static get placeholder(): string {
    return '概要';
  }

  /**
   * バリデーションルール
   */
  static get validationRule() {
    return {
    };
  }

  /**
   * キー
   */
  static get key(): string {
    return 'abstract';
  }

  /**
   * タイプ
   */
  static get type(): string {
    return 'text';
  }

  /**
   * 表示を返す
   * @returns 表示
   */
  override toString() {
    return this.value;
  }
}
